export const AGREE_COOKIE_KEY: string = 'insaiderCookieAgree';